"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var rxjs_1 = require("rxjs");

var operators_1 = require("rxjs/operators");

var actions_1 = require("./actions");

var helpers_1 = require("./helpers");

function createReduxSdkMiddleware(sdk) {
  var _sdk$state = sdk.state,
      initialized$ = _sdk$state.initialized$,
      connected$ = _sdk$state.connected$,
      authenticated$ = _sdk$state.authenticated$,
      account$ = _sdk$state.account$,
      accountDevice$ = _sdk$state.accountDevice$,
      accountFriendRecovery$ = _sdk$state.accountFriendRecovery$,
      device$ = _sdk$state.device$,
      ens$ = _sdk$state.ens$,
      eth$ = _sdk$state.eth$,
      incomingAction$ = _sdk$state.incomingAction$;
  return function (store) {
    setTimeout(function () {
      rxjs_1.merge(initialized$.pipe(operators_1.map(helpers_1.createActionCreator(actions_1.ReduxSdkActionTypes.SetInitialized))), connected$.pipe(operators_1.map(helpers_1.createActionCreator(actions_1.ReduxSdkActionTypes.SetConnected))), account$.pipe(operators_1.map(helpers_1.createActionCreator(actions_1.ReduxSdkActionTypes.SetAccount))), accountDevice$.pipe(operators_1.map(helpers_1.createActionCreator(actions_1.ReduxSdkActionTypes.SetAccountDevice))), accountFriendRecovery$.pipe(operators_1.map(helpers_1.createActionCreator(actions_1.ReduxSdkActionTypes.SetAccountFriendRecovery))), device$.pipe(operators_1.map(helpers_1.createActionCreator(actions_1.ReduxSdkActionTypes.SetDevice))), ens$.pipe(operators_1.map(helpers_1.createActionCreator(actions_1.ReduxSdkActionTypes.SetEns))), eth$.pipe(operators_1.map(helpers_1.createActionCreator(actions_1.ReduxSdkActionTypes.SetEth))), incomingAction$.pipe(operators_1.map(helpers_1.createActionCreator(actions_1.ReduxSdkActionTypes.SetIncomingAction))), authenticated$.pipe(operators_1.map(helpers_1.createActionCreator(actions_1.ReduxSdkActionTypes.SetAuthenticated)))).subscribe(store.dispatch);
    }, 0);
    return function (next) {
      return function (action) {
        return next(action);
      };
    };
  };
}

exports.createReduxSdkMiddleware = createReduxSdkMiddleware;